/* global axios */
import ApiClient from './ApiClient';

class GoogleCalendarAPI extends ApiClient {
  constructor() {
    super('google_calendar', { accountScoped: true });
  }

  // Sync a specific Pipeline card to Google Calendar
  syncToGoogle(pipelineCardId) {
    return axios.post(`${this.url}/sync_to_google`, {
      pipeline_card_id: pipelineCardId,
    });
  }

  // Sync from a Google Calendar event to Pipeline card
  syncFromGoogle(pipelineCardId, googleEventId) {
    return axios.post(`${this.url}/sync_from_google`, {
      pipeline_card_id: pipelineCardId,
      google_event_id: googleEventId,
    });
  }

  // Remove a Pipeline card from Google Calendar
  removeFromGoogle(pipelineCardId) {
    return axios.delete(`${this.url}/remove_from_google`, {
      data: { pipeline_card_id: pipelineCardId },
    });
  }

  // Toggle Google Calendar sync for a Pipeline card
  toggleSync(pipelineCardId, enabled, removeFromGoogle = false) {
    return axios.post(`${this.url}/toggle_sync`, {
      pipeline_card_id: pipelineCardId,
      enabled: enabled,
      remove_from_google: removeFromGoogle,
    });
  }

  // Get sync status and statistics
  getSyncStatus() {
    return axios.get(`${this.url}/sync_status`);
  }

  // Bulk operations
  bulkSync(action, pipelineIds = []) {
    return axios.post(`${this.url}/bulk_sync`, {
      // sync_action (não `action`): `action` colide com o param de roteamento do
      // Rails e o backend sempre lia 'bulk_sync' → 400.
      sync_action: action, // 'enable', 'disable', 'sync_to_google'
      pipeline_ids: pipelineIds,
    });
  }

  // Enable sync for multiple items
  bulkEnable(pipelineIds = []) {
    return this.bulkSync('enable', pipelineIds);
  }

  // Disable sync for multiple items
  bulkDisable(pipelineIds = []) {
    return this.bulkSync('disable', pipelineIds);
  }

  // Sync multiple items to Google Calendar
  bulkSyncToGoogle(pipelineIds = []) {
    return this.bulkSync('sync_to_google', pipelineIds);
  }
}

export default new GoogleCalendarAPI();
